export default {
  brigade: [],
  one_brigade: [],
  workTypeLoading: false,
}
